import { useCallback } from 'react';
import { useFollowCommunityMutation, useUnfollowCommunityMutation } from './';
import { useGetPublicUserByUserNameQuery } from './queries';

export interface UseFollowToggleResult {
	isFollowing: boolean;
	isLoading: boolean;
	onToggleFollow: () => Promise<void>;
}

export interface UseFollowToggleOptions {
	username: string;
}

export const useFollowToggle = ({ username }: UseFollowToggleOptions): UseFollowToggleResult => {
	const { data: hostData, isFetching: isHostDataFetching } = useGetPublicUserByUserNameQuery(username);

	const { handleFollowCommunity, isFollowCommunityLoading } = useFollowCommunityMutation(hostData?.id ?? '', username);

	const { handleUnfollowCommunity, isUnfollowCommunityLoading } = useUnfollowCommunityMutation(
		hostData?.id ?? '',
		username
	);

	const isLoading = isFollowCommunityLoading || isUnfollowCommunityLoading || isHostDataFetching;
	const isFollowing = Boolean(hostData?.isCurrentUserSubscribed);

	const onToggleFollow = useCallback(async () => {
		if (!hostData?.id) {
			console.warn('Cannot follow/unfollow: host data not loaded');

			return;
		}

		if (isFollowing) {
			await handleUnfollowCommunity();
		} else {
			await handleFollowCommunity();
		}
	}, [hostData, isFollowing, handleUnfollowCommunity, handleFollowCommunity]);

	return {
		isFollowing,
		isLoading,
		onToggleFollow,
	};
};
